import Table from './Table'
import Table2 from './Table2'
import TableCells from './TableCells'
import Tree from './Tree'
//import TreeD3 from './TreeD3';
import List from './List'
import RadioBox from './RadioBox'
import SelectBox from './SelectBox'
import Slider from './Slider'
import SearchAutocomplete from './SearchAutocomplete'
import Tab from './Tab'
import SplitLayout from './SplitLayout'
import SplitLayoutTest from './SplitLayoutTest'
import Yasgui from './Yasgui'
import BBMap from './bb/BBMap'
import BBTable from './bb/BBTable'
import BBTreeTable from './bb/BBTreeTable'
import BBYasgui from './bb/BBYasgui'
import BBYasr from './bb/BBYasr'
import BBYasguiNotebook from './bb/BBYasguiNotebook'
import BBNotebook from './bb/BBNotebook'
import BBKGApiVizWidget from './bb/BBKGApiVizWidget'
import BBVoyager from './bb/BBVoyager'
import BBAccordion from './bb/BBAccordion'
import BBPicture from './bb/BBPicture'
import BBHTML from './bb/BBHTML'
//import BBGridstack from './bb/BBGridstack';
import BBDForm from './bb/BBDForm'
//import BBForm from './bb/editor/BBForm';
//import BBGrid from './bb/editor/BBGrid';
import BBSideMenu from './bb/BBSideMenu'
import BBEChart from './bb/BBEChart'
import BBBoorkern from './bb/BBBoorkern'
import BBPropertyPanel from './bb/BBPropertyPanel'
import BBVis from './bb/BBVis'
import BBLinkButtons from './bb/BBLinkButtons'
import BBIFCViewer from './bb/BBIFCViewer'
import BBStructuredText from './bb/BBStructuredText'

//import BBLayout from './bb/BBLayout';
import BBKVKProductTemplate from './bb/kvk/BBKVKProductTemplate'
import BBKVKFlexibleTextWidget from './bb/kvk/BBKVKFlexibleTextWidget'
import BBBackMenu from './bb/BBBackMenu'
import BBSimplePushButton from './bb/BBSimplePushButton'
import BBVenn from './bb/BBVenn'
import BBForm from './bb/BBForm'
import BBUpload from './bb/BBUpload'
import BBNOML from './bb/BBNOML'
import ButtonPopup from './bb/rotterdam/ButtonPopup'
import BBRDFViewer from './bb/BBRDFViewer'
import BBCesium from './bb/BBCesium'
import BBRDFViewerOnline from './bb/BBRDFViewerOnline'
import BBMultiSelect from './bb/BBMultiSelect'

// import Search from './Search';

let widgetDefinitions = [
  SplitLayout.getDescription(),
  SplitLayoutTest.getDescription(),

  BBEChart.getDescription(),
  BBVis.getDescription(),
  Tab.getDescription(),
  List.getDescription(),

  Slider.getDescription(),
  SelectBox.getDescription(),
  BBMultiSelect.getDescription(),
  RadioBox.getDescription(),
  SearchAutocomplete.getDescription(),
  Tree.getDescription(),
  BBSideMenu.getDescription(),
  BBPropertyPanel.getDescription(),
  //TreeD3.getDescription(),
  Table.getDescription(),
  Table2.getDescription(),
  TableCells.getDescription(),
  {
    name: 'Yasgui',
    component: Yasgui,
    label: 'Yasgui widget',
  },
  BBTable.getDescription(),
  BBBoorkern.getDescription(),
  BBTreeTable.getDescription(),
  BBMap.getDescription(),
  BBCesium.getDescription(),
  BBYasgui.getDescription(),
  BBNOML.getDescription(),
  BBVoyager.getDescription(),
  {
    name: 'BBYasguiNotebook',
    component: BBYasguiNotebook,
    label: 'BB YasGUINotebook',
    variables: [],
  },
  {
    name: 'BBNotebook',
    component: BBNotebook,
    label: 'BB Notebook',
    variables: [],
  },
  BBYasr.getDescription(),
  {
    name: 'BBKGApiVizWidget',
    component: BBKGApiVizWidget,
    label: 'BBKGApiVizWidget',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label: 'just to start. ',
      },
    ],
  },
  BBAccordion.getDescription(),
  BBDForm.getDescription(),

  BBPicture.getDescription(),
  BBHTML.getDescription(),
  BBKVKProductTemplate.getDescription(),
  BBKVKFlexibleTextWidget.getDescription(),
  BBLinkButtons.getDescription(),
  BBIFCViewer.getDescription(),
  BBBackMenu.getDescription(),
  BBSimplePushButton.getDescription(),
  BBStructuredText.getDescription(),
  BBVenn.getDescription(),
  BBForm.getDescription(),
  BBUpload.getDescription(),
  ButtonPopup.getDescription(),
  BBRDFViewer.getDescription(),
  BBRDFViewerOnline.getDescription(),
]

export default widgetDefinitions
